var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loading-overlay"},[_c(_vm.injections.components.LoadingSign,{tag:"component",attrs:{"loadingmessage1":_vm.props.loadingmessage,"color":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }